import React from 'react';
import { exportEventName } from '.';
import { safeMutate } from '../../../../utils/GeneralUtils';
import PieChart from '../../Reports/templates/PieChart';
import WidgetBodyWrapper from '../WidgetBodyWrapper';
import getChartConfig, { chartOnlyMetrics } from './utils';
import { isPresent } from '../../../../utils/CoreExtensions/ArrayExtensions';
import useChartReflow from '../../../../hooks/generic/charts/useChartReflow';
import { orderedDeepMerge } from '../../../../utils/CoreExtensions/ObjectExtensions';


const Body = (props) => {
  const { metrics, name } = props;
  const numericMetrics = metrics.filter(metric => !chartOnlyMetrics.includes(metric.uId));
  const visibleChartMetrics = metrics.filter(metric => chartOnlyMetrics.includes(metric.uId));
  const isSplitWidget = isPresent(numericMetrics);
  const { chartWrapperReference, chartCallbackFunction } = useChartReflow();
  const childClass = `col-12 col-md-6 ${!isSplitWidget && "mx-auto"} dynamic-grid-item-child`;
  const propsForNumericMetrics = safeMutate(props, draftProps => {
    draftProps.metrics = numericMetrics;
  });
  const defaultChartConfig = getChartConfig({ metrics, name });
  let customChartConfig = {};
  if (visibleChartMetrics.length > 4)
    customChartConfig = { chart: { height: 320 }, legend: { itemMarginTop: 8, itemMarginBottom: 8 } }
  const chartConfig = orderedDeepMerge(defaultChartConfig, customChartConfig)

  return (
    <div className="custom-max-height-550-px p-3">
      <div className='row no-gutters' ref={ chartWrapperReference }>
        <div className={ `cui-widget-pie-chart ${childClass}` }>
          <PieChart
            chartOptions={ chartConfig }
            configs={ { export: true, exportEventName } }
            callbackFn={ chartCallbackFunction }
          />
        </div>
        { isSplitWidget &&
          <div className={childClass}>
            <WidgetBodyWrapper { ...propsForNumericMetrics } wrapperPadding="py-3" />
          </div>
        }
      </div>
    </div>
  );
};
export default Body;
